<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/guMJWd/tc-custom/9781466806597.jpg?1735616727855" alt="This image is the cover for the book Body in the Kelp, The Faith Fairchild Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Body in the Kelp, The Faith Fairchild Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The second mystery in the Agatha Award–winning series: “Great characters, a wonderful plot, and a puzzle laid out in the unfinished threads of a quilt.” —<i>Ocala Star-Banner</i></b><br/><br/>New York caterer-turned-minister’s wife Faith Fairchild and her husband, Tom, have left the little village of Aleford, Massachusetts for a summer on Sanpere Island, off the coast of Maine. But Tom is called away to a three-week religious retreat in New Hampshire, leaving Faith to amuse herself and care for Benjamin, who’s currently in what parents call the “terrible twos” stage.<br/><br/>The summer begins innocently enough, with Faith involved in a seemingly harmless mystery—a hunt for treasure, the clues to which are cryptically embedded in a patchwork quilt she bought at an estate auction. But the trail leads instead to the body of another summer resident along the beach, and Faith is forced into more serious—and dangerous—kind of detection . . .<br/><br/>“[A] highly entertaining series.” —<i>Booklist</i><br/><br/>“[Page’s] young sleuth is a charmer.” —<i>The New York Times Book Review</i><br/><br/>“Page is known for leavening her work with humor and warmth.” —<i>The Boston Herald</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katherine Hall Page
      </h2>
      
      <p class="authorDescription body article">Katherine Hall Page’s first mystery, <I>The Body in the Belfry</I>, won an Agatha Award for Best First Mystery Novel. The fifteenth in the series, <I>The Body in the Snowdrift</I>, won the Agatha Award for Best Mystery Novel. Page was also awarded the Agatha for Best Short Story for "The Would-Be Widower" in the Malice Domestic X collection. She was an Edgar nominee for her juvenile mystery, <I>Christie & Company Down East</I>. <I>The Body in the Lighthouse</I> was one of three nominees for The Mary Higgins Clark Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2771d00d